import { GROUND_Y, PLAYER_HITBOX, WORLD_TOP } from '../data/tuning';
import type { Aabb } from './collision';
import type { PlayerState } from './physics';

const HALF_W = PLAYER_HITBOX.width / 2;
const HALF_H = PLAYER_HITBOX.height / 2;

/** Highest centre the plane can reach: the ceiling minus half the hitbox (11.75 u, GDD §5.2). */
export const CEILING_Y = WORLD_TOP - HALF_H;

/** Player hitbox: 1.2 x 0.5 u centred on the fuselage. It never rotates with the pitch (GDD §4.1). */
export function playerAabb(player: Pick<PlayerState, 'x' | 'y'>): Aabb {
  return { x: player.x, y: player.y, halfW: HALF_W, halfH: HALF_H };
}

/**
 * True when the bottom edge of the hitbox touches or passes the ground (touching counts). Evaluated in
 * phase 5 of the tick as a damaging collision with source "ground" (#30, #37). El Salto disables it (#93).
 */
export function groundContact(player: Pick<PlayerState, 'y'>): boolean {
  return player.y - HALF_H <= GROUND_Y;
}
